import * as React from "react"
import { slugify } from "../../../../Shared/utils/string";

export type ExpandProps = { key: string; title: string; text?: string; open: boolean, child?: JSX.Element, onClick?: (e?) => void }

export const ExpandItem = (props: ExpandProps) => (
  <li key={slugify(props.key)} className={`expand__item expand__item--${props.open ? "open" : "closed"}`}>
    <button
      className="expand__button"
      onClick={props.onClick}
      aria-controls={`a11y-${slugify(props.key)}`}
      aria-expanded={props.open}
    >
      <span>{props.title}</span>
      <span className="expand__item--label">Lees meer</span>
    </button>

    {props.child != null
      ? <div
        id={`a11y-${slugify(props.key)}`}
        aria-hidden={!props.open}
        className="expand__content container--s text--styled"
      >
        {props.child}
      </div>
      : <div
        id={`a11y-${slugify(props.key)}`}
        aria-hidden={!props.open}
        dangerouslySetInnerHTML={{ __html: props.text }}
        className="expand__content container--s text--styled"
      />
    }
  </li>
)

{/* TH: Added to styleguide! */}
